import styled from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled(Form)`
  .textarea .ql-toolbar.ql-snow {
    border-radius: 4px 4px 0px 0px;
  }

  .textarea .ql-container.ql-snow {
    border-radius: 0px 0px 4px 4px;
  }

  .textarea .ql-editor {
    height: 200px;
  }

  .btn-upload {
    border-radius: 4px;
    background: #ff6900;
    border: none;
    line-height: 24px;
    cursor: pointer;
  }

  .height-hour {
    border: 1px solid #d3d3d3 !important;
    height: 36px;
    border-radius: 4px;

    input {
      padding: 0;
      font-size: 13px;
      color: #5d5d5d;
    }
    input::placeholder {
      color: #878787;
      font-size: 13px;
    }
  }
`;
